/* eslint-disable no-plusplus */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-computed-key */
import React, { useState, useEffect } from 'react'
import {
  onConvertNumber,
  onGetTIR,
  onFormatTIRValue,
  onFormatResultValue,
  onFormatNegate,
} from 'utils'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faAlignJustify } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import styles from './calculadora.module.css'

const JurosCompostos = () => {
  const defaultInputValue = '0,00'
  const [linkToRedirect, setLinkToRedirect] = useState(null)
  const [formulaType, setFomulaType] = useState(false)
  const [decimal, setDecimal] = useState(2)
  const [updateDecimal, setUpdateDecimal] = useState(false)
  const [inputSelected, setInputSelected] = useState(0)
  const [inputResult, setInputResult] = useState(2)
  const [inputs, onSetInputs] = useState([
    {
      value: defaultInputValue.toString(),
      selected: true,
      result: false,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: true,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: false,
    },
    {
      value: defaultInputValue.toString(),
      selected: false,
      result: false,
    },
  ])

  const inputValue1 = parseFloat(onConvertNumber(inputs[0].value))
  const inputValue2 = parseFloat(onConvertNumber(inputs[1].value))
  const inputValue3 = parseFloat(onConvertNumber(inputs[2].value))
  const inputValue4 = parseFloat(onConvertNumber(inputs[3].value))
  const inputValue5 = parseFloat(onConvertNumber(inputs[4].value))

  const inputResult1 = inputs[0].result
  const inputResult2 = inputs[1].result
  const inputResult3 = inputs[2].result
  const inputResult4 = inputs[3].result
  const inputResult5 = inputs[4].result

  const onKeyPress = event =>
    (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 0

  const onSetInput = id => {
    onSetInputs(current => ({
      ...current,
      [inputSelected]: {
        ...current[inputSelected],
        selected: false,
      },
    }))
    onSetInputs(current => ({
      ...current,
      [id]: {
        ...current[id],
        selected: true,
      },
    }))
    setInputSelected(id)
  }

  const onGetResult = () => {
    let result = 0
    let block = false
    let k = 0
    if (formulaType) {
      k = 1
    }
    let calc = 0
    const j = parseFloat(inputValue2, decimal) / 100
    let exp = (1 + j) ** parseFloat(inputValue1, decimal)
    const factor = 1 + j * k
    let vpl = 0
    let last = null
    let exit = 0
    let counter = 1
    let symbol = ''
    let symbol2 = ''
    let IRRval = null
    let iterMax = 800

    if (
      inputValue1.toString().slice(-1) === ',' ||
      inputValue2.toString().slice(-1) === ',' ||
      inputValue3.toString().slice(-1) === ',' ||
      inputValue4.toString().slice(-1) === ',' ||
      inputValue5.toString().slice(-1) === ','
    ) {
      block = true
    }

    if (!block) {
      if (inputResult1) {
        if (
          inputValue2 < 0 ||
          (inputValue3 > 0 && inputValue4 > 0 && inputValue5 > 0) ||
          (inputValue3 < 0 && inputValue4 < 0 && inputValue5 < 0) ||
          (inputValue3 === 0 && inputValue4 < 0 && inputValue5 < 0) ||
          (inputValue3 < 0 && inputValue4 === 0 && inputValue5 < 0) ||
          (inputValue3 < 0 && inputValue4 < 0 && inputValue5 === 0) ||
          (inputValue3 === 0 && inputValue4 > 0 && inputValue5 > 0) ||
          (inputValue3 > 0 && inputValue4 === 0 && inputValue5 > 0) ||
          (inputValue3 > 0 && inputValue4 > 0 && inputValue5 === 0)
        ) {
          result = '#NUM!'
        } else {
          do {
            exp = (1 + j) ** counter
            vpl =
              inputValue3 +
              (inputValue4 * [(exp - 1) / (j * exp)] * factor +
                inputValue5 / exp)

            if (vpl >= 0) {
              symbol = '+'
            } else {
              symbol = '-'
            }
            if (last) {
              if (last >= 0) {
                symbol2 = '+'
              } else {
                symbol2 = '-'
              }
            } else {
              symbol2 = symbol
            }

            if (vpl === 0) {
              if (Number.isNaN(counter)) {
                counter = '#NUM!'
              }
              result = counter
              exit++
            } else if (vpl === '0' || symbol !== symbol2) {
              if (Number.isNaN(counter)) {
                counter = '#NUM!'
              }
              result = counter
              exit++
            }

            if (Number.isNaN(vpl)) {
              result = '#NUM!'
              exit++
            }
            last = vpl
            counter++
          } while (exit === 0 && counter < iterMax)
        }
      } else if (inputResult2) {
        const soma =
          parseFloat(inputValue3) +
          parseFloat(inputValue5) +
          parseFloat(inputValue1) * parseFloat(inputValue4)

        IRRval = parseFloat(inputValue3) + parseFloat(inputValue4) * k

        for (let i = 1; i < inputValue1; i++) {
          IRRval += ', '
          IRRval += inputValue4
        }

        IRRval += ', '
        IRRval += parseFloat(inputValue5) + (1 - k) * parseFloat(inputValue4)

        if (parseFloat(inputValue3) < 0) {
          if (soma < 0) {
            result = 'i < 0'
          } else {
            result = Math.abs(
              onGetTIR(IRRval.split(',').map(valor => parseFloat(valor))),
            )
          }
        } else if (parseFloat(inputValue3) > 0) {
          if (soma > 0) {
            result = 'i < 0'
          } else {
            result = Math.abs(
              onGetTIR(IRRval.split(',').map(valor => parseFloat(valor))),
            )
          }
        } else if (parseFloat(inputValue3) === 0) {
          if (parseFloat(inputValue4) < 0) {
            if (soma < 0) {
              result = 'i < 0'
            } else {
              result = Math.abs(
                onGetTIR(IRRval.split(',').map(valor => parseFloat(valor))),
              )
            }
          } else if (parseFloat(inputValue4) > 0) {
            if (soma > 0) {
              result = 'i < 0'
            } else {
              result = Math.abs(
                onGetTIR(IRRval.split(',').map(valor => parseFloat(valor))),
              )
            }
          }
        }
      } else if (inputResult3) {
        calc =
          -inputValue4 * ((exp - 1) / (j * exp)) * factor - inputValue5 / exp
        if (Number.isNaN(calc)) {
          calc = '#NUM!'
        }
        result = calc
      } else if (inputResult4) {
        calc =
          -inputValue3 * ((j * exp) / (exp - 1)) * (1 / factor) -
          inputValue5 * (j / (exp - 1)) * (1 / factor)
        if (Number.isNaN(calc)) {
          calc = '#NUM!'
        }
        result = calc
      } else if (inputResult5) {
        calc = -inputValue3 * exp - inputValue4 * ((exp - 1) / j) * factor
        if (Number.isNaN(calc)) {
          calc = '#NUM!'
        }
        result = calc
      }
    }

    if (Number.isNaN(result) || result === '#NUM!') {
      onSetInputs(current => ({
        ...current,
        [inputResult]: {
          ...current[inputResult],
          value: '0,00',
        },
      }))
    } else if (result === 'i < 0') {
      onSetInputs(current => ({
        ...current,
        [inputResult]: {
          ...current[inputResult],
          value: 'i < 0',
        },
      }))
    } else {
      if (!block) {
        onSetInputs(current => ({
          ...current,
          [inputResult]: {
            ...current[inputResult],
            value: inputResult2
              ? onFormatTIRValue(result, decimal)
              : onFormatResultValue(result, decimal),
          },
        }))
      }
    }
  }

  const onChangeResultType = status => {
    setFomulaType(formulaType === status ? false : status)
  }

  useEffect(() => {
    onGetResult()
  }, [decimal])

  const onAddDigit = num => {
    let inputValue = 0

    if (
      inputs[inputSelected].value === '0' ||
      inputs[inputSelected].value === '0,00'
    ) {
      inputValue = num
    } else {
      inputValue = '' + inputs[inputSelected].value + num
    }

    if (updateDecimal) {
      setDecimal(num)
      setUpdateDecimal(false)
    } else {
      if (!inputs[inputSelected].result) {
        onSetInputs(current => ({
          ...current,
          [inputSelected]: {
            ...current[inputSelected],
            value: inputValue,
          },
        }))
      }
    }
  }

  const onAddDigitDecimal = () => {
    let inputValue = inputs[inputSelected].value.toString()
    if (inputValue.indexOf(',') === -1) {
      inputValue += ','
      onSetInputs(current => ({
        ...current,
        [inputSelected]: {
          ...current[inputSelected],
          value: inputValue,
        },
      }))
    }
  }

  const onClearAllInputs = () => {
    for (let index = 0; index < 5; index++) {
      onSetInputs(current => ({
        ...current,
        [index]: {
          ...current[index],
          value: defaultInputValue.toString(),
        },
      }))
    }
  }

  const onClearSelectedInput = () => {
    onSetInputs(current => ({
      ...current,
      [inputSelected]: {
        ...current[inputSelected],
        value: defaultInputValue.toString(),
      },
    }))
  }

  const onNegate = () => {
    onSetInputs(current => ({
      ...current,
      [inputSelected]: {
        ...current[inputSelected],
        value: onFormatNegate(inputs[inputSelected].value),
      },
    }))
  }

  const onSetResult = () => {
    onSetInputs(current => ({
      ...current,
      [inputResult]: {
        ...current[inputResult],
        result: false,
        selected: false,
      },
    }))
    if (inputResult < 4) {
      onSetInputs(current => ({
        ...current,
        [inputResult + 1]: {
          ...current[inputResult + 1],
          result: true,
          selected: false,
        },
      }))

      if (inputSelected === inputResult + 1) {
        onSetInputs(current => ({
          ...current,
          [inputSelected === inputResult + 1
            ? inputSelected + 1
            : inputSelected]: {
            ...current[
              inputSelected === inputResult + 1
                ? inputSelected + 1
                : inputSelected
            ],
            result: false,
            selected: true,
          },
        }))
      }

      if (inputSelected === 4) {
        onSetInputs(current => ({
          ...current,
          [0]: {
            ...current[0],
            result: false,
            selected: true,
          },
        }))
        setInputSelected(0)
      } else {
        setInputSelected(
          inputSelected === inputResult + 1 ? inputSelected + 1 : inputSelected,
        )
      }

      setInputResult(inputResult + 1)
    } else {
      onSetInputs(current => ({
        ...current,
        [0]: {
          ...current[0],
          result: true,
          selected: false,
        },
      }))
      onSetInputs(current => ({
        ...current,
        [1]: {
          ...current[1],
          result: false,
          selected: true,
        },
      }))
      setInputSelected(1)
      setInputResult(0)
    }
  }

  const onSetDecimal = () => {
    setUpdateDecimal(true)
  }

  const handleChange = () => false

  if (linkToRedirect) {
    return <Redirect to={linkToRedirect} />
  }

  return (
    <>
      <div className={styles.container}>
        <header>
          <h1 id="titulo" className={styles.title}>
            Calculadora Financeira – AP
          </h1>
          <h2 id="tema" className={styles.subtitle}>
            Juros Compostos – Diagrama Padrão
          </h2>
        </header>
        <div id="calculadora" className={styles.calculadora}>
          <section id="entradas">
            <div className="form entradas">
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>n</span>
                <input
                  readOnly
                  style={
                    inputs[0].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[0].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-1}
                  onChange={() => handleChange()}
                  value={inputs[0].value}
                  className={styles.inputSize}
                  id="n"
                  type="text"
                  name="n"
                  disable={inputs[0].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(0)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>i</span>
                <input
                  readOnly
                  style={
                    inputs[1].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[1].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-2}
                  onChange={() => handleChange()}
                  value={inputs[1].value}
                  className={styles.inputSize}
                  id="i"
                  type="text"
                  name="i"
                  disable={inputs[1].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(1)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>PV</span>
                <input
                  readOnly
                  style={
                    inputs[2].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[2].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-3}
                  onChange={() => handleChange()}
                  value={inputs[2].value}
                  className={styles.inputSize}
                  id="pv"
                  type="text"
                  name="pv"
                  disable={inputs[2].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(2)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>PMT</span>
                <input
                  readOnly
                  style={
                    inputs[3].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[3].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-4}
                  onChange={() => handleChange()}
                  value={inputs[3].value}
                  className={styles.inputSize}
                  id="pmt"
                  type="text"
                  name="pmt"
                  disable={inputs[3].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(3)}
                />
              </div>
              <div className={styles.inputGroup}>
                <span className={styles.spanText}>FV</span>
                <input
                  readOnly
                  style={
                    inputs[4].result
                      ? { backgroundColor: 'rgba(84, 212, 84, 0.57)' }
                      : inputs[4].selected
                      ? { backgroundColor: 'rgba(199, 211, 217, 0.58)' }
                      : { backgroundColor: 'white' }
                  }
                  tabIndex={-5}
                  onChange={() => handleChange()}
                  value={inputs[4].value}
                  className={styles.inputSize}
                  id="fv"
                  type="text"
                  name="fv"
                  disable={inputs[4].result.toString()}
                  onKeyPress={e => onKeyPress(e)}
                  onFocus={() => onSetInput(4)}
                />
              </div>
            </div>
          </section>
          <section id="botoes">
            <div className="form buttons">
              <button
                className={
                  formulaType
                    ? styles.buttonLargeYellow
                    : styles.buttonLargeDark
                }
                id="comercial"
                tabIndex={-5}
                onClick={() => onChangeResultType(true)}
              >
                PMT – BEGIN
              </button>
            </div>
          </section>
        </div>
        <section id="keyboard">
          <div className={styles.row}>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(1)}
            >
              1
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(2)}
            >
              2
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(3)}
            >
              3
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(4)}
            >
              4
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(5)}
            >
              5
            </button>
            <button
              className={styles.keyButtonDark}
              id="limpar"
              tabIndex="-1"
              onClick={() => onClearAllInputs()}
            >
              <font size="2">Clear</font>
            </button>
          </div>
          <div className={styles.row}>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(6)}
            >
              6
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(7)}
            >
              7
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(8)}
            >
              8
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(9)}
            >
              9
            </button>
            <button
              className={styles.keyButtonLight}
              tabIndex="-1"
              onClick={() => onAddDigit(0)}
            >
              0
            </button>
            <button
              className={styles.keyButtonDark}
              tabIndex="-1"
              onClick={() => onClearSelectedInput()}
            >
              clx
            </button>
          </div>
          <div className={styles.row}>
            <button
              className={styles.keyButtonGreen}
              id="calc"
              tabIndex="-1"
              onClick={() => onGetResult()}
            >
              Calc
            </button>
            <button
              className={styles.keyButtonDark}
              id="pontuacao"
              tabIndex="-1"
              onClick={() => onAddDigitDecimal()}
            >
              ,
            </button>
            <button
              className={styles.keyButtonDark}
              tabIndex="-1"
              onClick={() => onNegate()}
            >
              + / -
            </button>
            <button
              className={styles.keyButtonDark}
              tabIndex="-1"
              onClick={() => onSetDecimal()}
            >
              Dec.
            </button>
            <button
              className={styles.keyButtonDark}
              tabIndex="-1"
              onClick={() => onSetResult()}
            >
              <FontAwesomeIcon icon={faArrowDown} />
            </button>
            <button
              className={styles.keyButtonDark}
              tabIndex="-1"
              onClick={() =>
                confirmAlert({
                  customUI: ({ onClose }) => {
                    return (
                      <div className={styles.alert}>
                        <h1>Atenção</h1>
                        <p>Deseja realmente voltar ao menu?</p>
                        <button
                          className={styles.alertButton}
                          onClick={() => {
                            setLinkToRedirect('/')
                            onClose()
                          }}
                        >
                          Sim
                        </button>
                        <button
                          className={styles.alertButton}
                          onClick={onClose}
                        >
                          Não
                        </button>
                      </div>
                    )
                  },
                })
              }
            >
              <FontAwesomeIcon icon={faAlignJustify} />
            </button>
          </div>
        </section>
      </div>
    </>
  )
}

export default JurosCompostos
